import { ReactElement } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Checkbox } from '@hopskipdrive/react-components';

import { StyledCheckboxField, StyledFormLabel } from '../IncidentForm.styles';

interface RiderBlockFieldProps {
  defaultValue?: boolean;
}

export const RiderBlockField = ({ defaultValue }: RiderBlockFieldProps): ReactElement => {
  const { control } = useFormContext();
  const { field } = useController({
    name: 'riderBlock',
    control,
    defaultValue,
  });

  return (
    <StyledCheckboxField display="flex" alignItems="center">
      <Checkbox
        name="riderBlock-checkbox"
        id="riderBlock-checkbox"
        checked={field.value}
        onClick={() => field.onChange(!field.value)}
      />
      <StyledFormLabel htmlFor="riderBlock-checkbox">Driver blocked (from rider&apos;s account)</StyledFormLabel>
    </StyledCheckboxField>
  );
};
